import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      "common.cta.contact": "Contact Me",
      "common.cta.viewWork": "View Work",
      "common.cta.showCV": "Show CV",
      "common.cta.sendMessage": "Send Message",
      "common.cta.viewAllProjects": "View All Projects",
      "common.labels.name": "Name",
      "common.labels.email": "Email",
      "common.labels.from": "From",
      "common.labels.freelance": "Freelance",
      "common.labels.available": "Available",
      "common.labels.phone": "Phone",
      "common.labels.location": "Location",
      "common.labels.subject": "Subject",
      "common.labels.message": "Your Message",
      "common.labels.yourName": "Your Name",
      "common.social.github": "GitHub Profile",
      "common.social.twitter": "Twitter Profile",
      "common.social.linkedin": "LinkedIn Profile",
      "common.social.instagram": "Instagram Profile",
      "common.status.privacyPolicy": "Privacy Policy",
      "common.status.termsOfService": "Terms of Service",
      "common.status.cookiesPolicy": "Cookies Policy",
      "common.status.comingSoon": "Coming Soon",
      "common.contact.placeholder": "Feel free to reach out to me for any questions or opportunities. I'm always open to discussing new projects, creative ideas or opportunities to be part of your vision.",
      "common.projects.placeholder": "I'm currently working on some exciting projects. Check back soon to see my latest work!",
      "common.projects.placeholderTitle": "Projects Coming Soon",
      "navbar.brand": "Ismaildev",
      "navbar.links.home": "Home",
      "navbar.links.about": "About",
      "navbar.links.skills": "Skills",
      "navbar.links.projects": "Projects",
      "navbar.links.contact": "Contact",
      "hero.greeting": "Hi, I'm",
      "hero.name": "Ismail",
      "hero.title": "React & React Native Developer",
      "hero.description": "I build beautiful, responsive, and performant web and mobile applications with modern technologies.",
      "about.title": "About",
      "about.coloredTitle": "Me",
      "about.heading.whoAmI": "Who am I?",
      "about.description.paragraph1": "I'm Ismail, a passionate React and React Native developer with 1+ years of experience in building modern web and mobile applications. I specialize in creating intuitive user interfaces and seamless user experiences.",
      "about.description.paragraph2": "My journey in software development began when I discovered my love for problem-solving and creating things that people find useful. Since then, I've worked on various projects ranging from small business websites to complex enterprise applications.",
      "about.info.name": "Ismail",
      "about.info.email": "ismail_coder@protonmail.com",
      "about.info.from": "Morocco-tangier",
      "about.info.freelanceStatus": "Available",
      "skills.title": "My",
      "skills.coloredTitle": "Skills",
      "skills.list.react": "React",
      "skills.list.reactNative": "React Native",
      "skills.list.javascript": "JavaScript",
      "skills.list.redux": "Redux",
      "skills.list.firebase": "Firebase",
      "skills.descriptions.react": "Building interactive UIs with component-based architecture",
      "skills.descriptions.reactNative": "Cross-platform mobile app development",
      "skills.descriptions.javascript": "Modern ES6+ features and functional programming",
      "skills.descriptions.redux": "State management for complex applications",
      "skills.descriptions.firebase": "Backend services and realtime database",
      "projects.title": "My",
      "projects.coloredTitle": "Projects",
      "projects.links.liveDemo": "Live Demo",
      "projects.links.code": "Code",
      "contact.title": "Get In",
      "contact.coloredTitle": "Touch",
      "contact.info.heading": "Contact Information",
      "contact.info.followHeading": "Follow Me",
      "contact.form.labels.name": "Your Name",
      "contact.form.labels.subject": "Subject",
      "contact.form.labels.message": "Your Message",
      "contact.form.message.required": "*",
      "footer.brand": "Ismaildev",
      "footer.tagline": "React & React Native Developer",
      "footer.copyright": "© 2025 Ismaildev. All rights reserved.",
      "aiChat.title": "AI Assistant",
      "aiChat.subtitle": "Ask me anything about Ismail",
      "aiChat.welcome": "Hello! I'm Ismail's AI assistant. I can help answer questions about his skills, experience, projects, and services. What would you like to know?",
      "aiChat.placeholder": "Type your question here...",
      "aiChat.error": "Sorry, I'm having trouble responding right now. Please try again later."
    }
  },
  ar: {
    translation: {
      "common.cta.contact": "تواصل معي",
      "common.cta.viewWork": "اعرض أعمالي",
      "common.cta.showCV": "عرض السيرة الذاتية",
      "common.cta.sendMessage": "إرسال الرسالة",
      "common.cta.viewAllProjects": "عرض جميع المشاريع",
      "common.labels.name": "الاسم",
      "common.labels.email": "البريد الإلكتروني",
      "common.labels.from": "من",
      "common.labels.freelance": "العمل الحر",
      "common.labels.available": "متاح",
      "common.labels.phone": "الهاتف",
      "common.labels.location": "الموقع",
      "common.labels.subject": "الموضوع",
      "common.labels.message": "رسالتك",
      "common.labels.yourName": "اسمك",
      "common.social.github": "ملف GitHub",
      "common.social.twitter": "ملف Twitter",
      "common.social.linkedin": "ملف LinkedIn",
      "common.social.instagram": "ملف Instagram",
      "common.status.privacyPolicy": "سياسة الخصوصية",
      "common.status.termsOfService": "شروط الخدمة",
      "common.status.cookiesPolicy": "سياسة ملفات تعريف الارتباط",
      "common.status.comingSoon": "قريباً",
      "common.contact.placeholder": "لا تتردد في التواصل معي لأي أسئلة أو فرص. أنا دائماً مفتوح لمناقشة مشاريع جديدة أو أفكار إبداعية أو فرص لتكون جزءاً من رؤيتك.",
      "common.projects.placeholder": "أعمل حالياً على بعض المشاريع المثيرة. تفقدنا قريباً لرؤية أعمالي الأخيرة!",
      "common.projects.placeholderTitle": "المشاريع قادمة قريباً",
      "navbar.brand": "Ismaildev",
      "navbar.links.home": "الرئيسية",
      "navbar.links.about": "عني",
      "navbar.links.skills": "المهارات",
      "navbar.links.projects": "المشاريع",
      "navbar.links.contact": "تواصل",
      "hero.greeting": "مرحباً، أنا",
      "hero.name": "Ismail",
      "hero.title": "مطور React & React Native",
      "hero.description": "أبني تطبيقات ويب وتطبيقات محمولة جميلة وسريعة الاستجابة وحديثة باستخدام التقنيات المتطورة.",
      "about.title": "عن",
      "about.coloredTitle": "نفسي",
      "about.heading.whoAmI": "من أنا؟",
      "about.description.paragraph1": "أنا إسماعيل، مطور React و React Native شغوف مع أكثر من سنة واحدة من الخبرة في بناء تطبيقات ويب وتطبيقات محمولة حديثة. أتميز في إنشاء واجهات مستخدم بديهية وتجارب مستخدم سلسة.",
      "about.description.paragraph2": "بدأت رحلتي في تطوير البرمجيات عندما اكتشفت حبي لحل المشاكل وإنشاء أشياء مفيدة للناس. ومنذ ذلك الحين، عملت على مشاريع متنوعة تتراوح من مواقع أعمال صغيرة إلى تطبيقات مؤسسية معقدة.",
      "about.info.name": "Ismail",
      "about.info.email": "ismail_coder@protonmail.com",
      "about.info.from": "المغرب - طنجة",
      "about.info.freelanceStatus": "متاح",
      "skills.title": "مهاراتي",
      "skills.coloredTitle": "",
      "skills.list.react": "React",
      "skills.list.reactNative": "React Native",
      "skills.list.javascript": "JavaScript",
      "skills.list.redux": "Redux",
      "skills.list.firebase": "Firebase",
      "skills.descriptions.react": "بناء واجهات مستخدم تفاعلية مع بنية قائمة على المكونات",
      "skills.descriptions.reactNative": "تطوير تطبيقات محمولة متعددة المنصات",
      "skills.descriptions.javascript": "ميزات ES6+ الحديثة والبرمجة الوظيفية",
      "skills.descriptions.redux": "إدارة الحالة للتطبيقات المعقدة",
      "skills.descriptions.firebase": "خدمات الخادم الخلفي وقاعدة البيانات الفورية",
      "projects.title": "مشروعي",
      "projects.coloredTitle": "عاتي",
      "projects.links.liveDemo": "العرض المباشر",
      "projects.links.code": "الكود",
      "contact.title": "تواصل",
      "contact.coloredTitle": "معي",
      "contact.info.heading": "معلومات التواصل",
      "contact.info.followHeading": "تابعني",
      "contact.form.labels.name": "اسمك",
      "contact.form.labels.subject": "الموضوع",
      "contact.form.labels.message": "رسالتك",
      "contact.form.message.required": "*",
      "footer.brand": "Ismaildev",
      "footer.tagline": "مطور React & React Native",
      "footer.copyright": "© 2025 Ismaildev. جميع الحقوق محفوظة.",
      "aiChat.title": "المساعد الذكي",
      "aiChat.subtitle": "اسألني أي شيء عن إسماعيل",
      "aiChat.welcome": "مرحبا! أنا المساعد الذكي لإسماعيل. يمكنني المساعدة في الإجابة على الأسئلة حول مهاراته وخبراته ومشاريعه وخدماته. ماذا تريد أن تعرف؟",
      "aiChat.placeholder": "اكتب سؤالك هنا...",
      "aiChat.error": "عذرا، أواجه صعوبة في الاستجابة الآن. يرجى المحاولة مرة أخرى لاحقا."
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: true,

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;